import { useWhatsAppLink } from "@/lib/whatsapp";

export function WhatsAppIcon({ size = 16, fill = "currentColor", className = "" }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill={fill} aria-hidden="true" className={className}>
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.966-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.148-.669-1.611-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.372-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.876 1.213 3.074.149.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347M12.03 3.6c-4.647 0-8.407 3.76-8.407 8.407 0 1.594.437 3.14 1.271 4.482L3.5 20.5l4.116-1.34a8.362 8.362 0 004.414 1.25h.004c4.646 0 8.406-3.76 8.406-8.407 0-2.246-.874-4.359-2.462-5.947A8.352 8.352 0 0012.03 3.6" />
    </svg>
  );
}

// The number lives only in the wa.me URL (REACT_APP_WHATSAPP_NUMBER), never in visible text.
export function WhatsAppButton({ variant = "primary", size = "md", className = "", label = "Chat on WhatsApp", source = "button", testId = "whatsapp-button" }) {
  const wa = useWhatsAppLink(source);
  if (!wa) return null;

  const styles = {
    primary: "bg-wafa-primary text-white hover:bg-wafa-deep",
    outline: "border border-wafa-deep/25 bg-white text-wafa-deep hover:bg-wafa-cream/40",
    knockout: "border border-white/25 bg-white/10 text-white hover:bg-white/20",
    whatsapp: "bg-[#25D366] text-white hover:bg-[#1ebe5a]",
  };
  const sizes = { md: "px-4 py-2.5", lg: "px-5 py-3" };

  return (
    <a
      href={wa.href}
      onClick={wa.onClick}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-md text-sm font-semibold transition-colors ${sizes[size]} ${styles[variant]} ${className}`}
    >
      <WhatsAppIcon size={16} />
      {label}
    </a>
  );
}
